import styled, { css } from 'styled-components';
import ThemedTooltip from '../../theme/ThemedTooltip';
import { InfoDarkRelative } from '../../globalStyled';
import { fontUi, pill } from '../../theme/typography';

export const StyledContainer = styled.section`
  position: relative;
  border-top: 1px solid ${({ theme }) => theme.borderSubtle};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  padding-top: 16px;
  margin-top: 16px;
  margin-bottom: 10px;
  @media only screen and (max-width: 768px) {
    margin-top: 12px;
  }
  > h4 {
    ${fontUi};
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 13px;
    line-height: 1.4;
    color: ${({ theme }) => theme.textMuted};
    margin: 8px 16px 16px;
    text-transform: none;
    > svg {
      cursor: pointer;
      user-select: none;
    }
  }
`;

export const StyledBlocksContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
`;

export const StyledReportLabel = styled.span`
  ${pill};
  padding: 6px 12px;
  background-color: ${({ theme }) => (theme.isDark ? theme.hover : '#ececec')};
  color: ${({ theme }) => theme.textMuted};
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 500;
  width: auto;
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  svg {
    margin-left: 5px;
  }
`;

export const StyledInfoIcon = styled(InfoDarkRelative)`
  width: 12px;
  height: 12px;
  top: 0;
  margin-left: 0px;
  filter: ${({ theme }) => (theme.isDark ? 'invert(1)' : 'none')};
  ${({ iconsize }) => {
    if (iconsize)
      return css`
        width: ${iconsize}px;
        height: ${iconsize}px;
      `;
  }}
  &:focus,
  &:active {
    outline: none;
  }
`;

export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  border: solid 0.5px #e1e1e1;
  width: 190px;
  &.__react_component_tooltip.show {
    color: #4e4e4e;
    font-size: 13px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;

export const StyledTooltipText = styled.span`
  text-transform: none;
`;
